import { render, staticRenderFns } from "./SectionHero.vue?vue&type=template&id=3a0e0544&scoped=true&"
import script from "./SectionHero.vue?vue&type=script&lang=js&"
export * from "./SectionHero.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a0e0544",
  null
  
)

export default component.exports